import { call, put, takeEvery } from "redux-saga/effects";
import { eQuanLyDangKyActionIds, eQuanLyDangKyActionsObj, IQuanLyDangKyActionTypes } from "../../action-types/quan-ly-dang-ky/IQuanLyDangKyActions";
import { IQuyDinhSoTinChiActionTypes } from "../../action-types/quan-ly-dang-ky/IQuyDinhSoTinChiActions";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { rootActions } from "../../actions/rootActions";
import { lopTinChiApi } from "../../../api/lop-tin-chi/lopTinChiApi";

const mainAction = rootActions.quanLyDangKy.quanLyDangKy;
export function* quanLyDangKySaga(): any {
    yield takeEvery(eQuanLyDangKyActionIds.LOAD_LOP_TIN_CHI_START, loadLopTinChiWorker);  
}



function* loadLopTinChiWorker(action: IQuanLyDangKyActionTypes): any {
    const { kyDangKys } = action.payload as { kyDangKys: number[] };
    const res: IBaseRespone = yield call(lopTinChiApi.SelectMultipleKyDangKy, { ids: kyDangKys });
    if (res.is_success) {
        yield put(mainAction.LOAD_LOP_TIN_CHI_SUCCESS(res.data));
    } else {
        yield put(mainAction.LOAD_LOP_TIN_CHI_ERROR(res.message ?? "Có lỗi"));
    }
}